// "What's New" announcement content. Bump ANNOUNCEMENT_VERSION whenever you ship
// a new batch of features — the popup will auto-show once again to everyone, and
// the "seen" check (backend lastSeenAnnouncement / localStorage) compares against
// this exact string.

export const ANNOUNCEMENT_VERSION = "2026.07";

export const ANNOUNCEMENT = {
  version: ANNOUNCEMENT_VERSION,
  title: "What's New",
  subtitle: "Introducing the 3D Lab on DSA Visualizer.",
  features: [
    {
      icon: "🧊",
      title: "Merge Sort in 3D",
      description:
        "Explore Merge Sort as an interactive 3D recursion tree — orbit around it, grab the top node to move the whole tree, and step through every split and merge with the code line, call stack, and array all in sync. Sign in to try it.",
    },
    {
      icon: "🧪",
      title: "It's a beta — more coming",
      description:
        "This is the first algorithm in the new 3D Lab. Quick Sort, N-Queens, and Binary Search are on the way — tell us which you want next via the Feedback link.",
    },
  ],
};
